import { Component, inject, Input, OnInit } from '@angular/core';
import { Scale } from '../../../models/scale';
import { SafeNumberPipe } from '../../../pipes/safe-number.pipe';
import { DecimalPipe, NgClass, NgIf } from '@angular/common';
import {
  Indicator,
  isIndicator,
  isWegweiserIndicator,
} from '../../../models/indicator';
import { DataLayerTypeIcon } from '../../../stores/data-layer-type/data-layer-type.selectors';
import {
  LegendSize,
  WegweiserIndicator,
} from '../../../services/grid-widget-config.service';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { ComparisonValueStore } from '../../../stores/comparison-value/comparison-value.state';

@Component({
  selector: 'app-legend',
  standalone: true,
  imports: [SafeNumberPipe, NgClass, NgIf],
  providers: [DecimalPipe, SafeNumberPipe],
  templateUrl: './legend.component.html',
  styleUrl: './legend.component.scss',
})
export class LegendComponent implements OnInit {
  @Input() indicator!: Indicator | WegweiserIndicator;
  @Input() scales: Scale[] = [];
  @Input() colors: string[] = [];
  @Input() icons?: DataLayerTypeIcon[];
  @Input() size: LegendSize = 'large';
  @Input() comparisonData?: { [key: string]: number };
  @Input() displayedComparisonValues?: string[];
  @Input() type: 'scale' | 'indicator' = 'scale'; // New: legend type
  @Input() indicators?: Indicator[]; // New: for indicator-only legend
  @Input() indicatorColors?: string[]; // New: colors for each indicator

  wegweiserLegend = false;

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of the component.
   * It sets the `wegweiserLegend` property based on the result of the `isWegweiserIndicator` function,
   * which evaluates the specified `indicator`.
   *
   * @return {void} This method does not return a value.
   */
  ngOnInit(): void {
    this.wegweiserLegend = isWegweiserIndicator(this.indicator);
  }

  readonly indicatorStore = inject(IndicatorStore);
  readonly comparisonStore = inject(ComparisonValueStore);
  protected readonly isIndicator = isIndicator;
}
